import { Control } from "react-hook-form";
import InputFieldComponent from "../../../components/molecule/InputField/InputFieldComponent";
import { conditionalFieldStyles } from "../../../utils/styles/styles";
import { Box } from "@chakra-ui/react";

export const renderAccountRoleSpecificFields = (
  selectedRole: any,
  control: Control<any>,
  errors: any,
  isDisabled?: boolean,
) => {
  if (selectedRole.level?.id === 2) {
    return (
      <InputFieldComponent
        label="Parceiro"
        name="partner"
        type="text"
        register={control.register}
        errors={errors}
        isDisabled={isDisabled}
        additionalStyle={conditionalFieldStyles}
      />
    );
  }

  return (
    <>
      <InputFieldComponent
        label="Província"
        name="province"
        type="text"
        register={control.register}
        errors={errors}
        isDisabled={isDisabled}
        additionalStyle={conditionalFieldStyles}
      />
      <InputFieldComponent
        label="Município"
        name="county"
        type="text"
        register={control.register}
        errors={errors}
        isDisabled={isDisabled}
        additionalStyle={conditionalFieldStyles}
      />
      <Box ml={5}>
        <InputFieldComponent
          label="Entidade"
          name="organization"
          type="text"
          register={control.register}
          errors={errors}
          isDisabled={isDisabled}
          additionalStyle={{ ...conditionalFieldStyles }}
        />
      </Box>
    </>
  );
};
